export const LOCALES = ["en", "pt"] as const;

export type Locale = (typeof LOCALES)[number];

/**
 * Record<Locale, …> rather than a partial map on purpose: a missing
 * translation is a compile error, not a blank string at runtime.
 */
export type Localized = Record<Locale, string>;
export type LocalizedList = Record<Locale, readonly string[]>;

/** Short label for the switcher. */
export const LOCALE_LABELS: Record<Locale, string> = {
  en: "EN",
  pt: "PT",
};

/** What goes in <html lang>. Regional tag matters for screen-reader voices. */
export const HTML_LANG: Record<Locale, string> = {
  en: "en",
  pt: "pt-BR",
};

export const LOCALE_NAMES: Record<Locale, string> = {
  en: "English",
  pt: "Português",
};
